import React, { FC } from 'react';
import { deepDaoLogoCircle } from 'assets';
import styles from './styles.module.scss';
import { HeaderRectangularButton } from 'components';
import { useHistoryPush } from 'hooks';

type TableProBlur = {
    position?: 'absolute' | 'relative';
    title?: string;
    description?: string;
};
export const TableProBlur: FC<TableProBlur> = ({
    position = 'absolute',
    title = 'DAO metadata is a DeepDAO Pro feature',
    description = 'Upgrade to Pro to access detailed financial and governance analytics',
}) => {
    const { navigateToProducts } = useHistoryPush();

    return (
        <div className={styles.bannerWrapper} style={{ position }}>
            <div className={styles.bannerContainer}>
                <img src={deepDaoLogoCircle} className={styles.logoCircle} alt="logo" />
                <h1 className={styles.title}>{title}</h1>
                <p className={styles.description}>{description}</p>
                <HeaderRectangularButton onClick={navigateToProducts} title={'Subscribe'} />
            </div>
        </div>
    );
};
